<div class="col-12 mt-4 table-wrapper">
  <!-- Energy pathways table -->
  @if (perimetersPathway$ | async; as perimetersPathway) {
    <table class="table table-hover">
      <thead>
        <tr>
          @if (objectiveType === 'energy') {
            <th scope="col" class="first-col">{{ "pages.energy.kwh_m2_year" | translate }}</th>
          }
          @if (objectiveType === 'carbon') {
            <th scope="col" class="first-col">{{ "kg_co2_m2_year" | translate }}</th>
          }
          @for (year of years; track year) {
            <th class="centered-cell" scope="col">{{ year }}</th>
          }
        </tr>
      </thead>
      <tbody>
        <!-- SITE ROWS-->
          @for (perimeterPathway of perimetersPathway; track perimeterPathway) {
            <tr>
              <td (click)="perimeterPathway.expanded = !perimeterPathway.expanded ? true : false" class="site-td"
                [class.dimmed]="!perimeterPathway.displayed">
                <fa-icon class="me-2" [icon]="['fas', !!perimeterPathway.expanded? 'caret-down' : 'caret-right']"></fa-icon>
                {{ perimeterPathway.name }}
              </td>
              @for (year of years; track year) {
                <td class="centered-cell">-</td>
              }
            </tr>
            @if (perimeterPathway.expanded) {
              @for (monosite of perimeterPathway.monositeObjectives; track monosite) {
                <tr>
                  <td class="perimeter-td" [class.dimmed]="!monosite.displayed">{{ monosite.name }}</td>
                  @if (objectiveType === 'energy') {
                    @for (consumption of monosite.consumption; track consumption){
                      <td class="centered-cell">
                        {{ (consumption | number:'1.0-0':'fr-FR') || '-' }}
                      </td>
                    }
                  }
                  @if (objectiveType === 'carbon') {
                    @for (emission of monosite.emission; track emission){
                      <td class="centered-cell">
                        {{ (emission | number:'1.1-1':'fr-FR') || '-' }}
                      </td>
                    }
                  }
                </tr>
              }
            }
          }
      </tbody>
    </table>
  }
</div>
